// Shared by Vuetify and the CSS generated for static pages.
module.exports = {
  ink: '#000000',
  muted: '#666666',
  line: '#eeeeee',
  accent: '#01579B',
  accentHover: '#014679',
  background: '#ffffff',
  surface: '#ffffff',
  navigation: '#343434',
  footer: '#424242',
};
